import { CircleAlert, RefreshCw } from 'lucide-react'
import clsx from 'clsx'
import { Button } from '../../Button'

type RecordPropertyProps = {
  message?: string
  onRecalculateClick?: () => void
}

export function RecordPropertyError (props: RecordPropertyProps) {
  const { message, onRecalculateClick } = props

  return (
    <div className="flex items-center gap-3 justify-between bg-error/10 px-2 py-1 h-full rounded-md">
      <span className="text-xs text-error font-semibold">Error</span>
      <div className="flex gap-1 items-center">
        <Button
          onClick={onRecalculateClick}
          size="xs"
          ghost
          color="error"
          className="hover:bg-error/50 rounded-full"
        >
          <RefreshCw size={16} />
        </Button>
        <span className={clsx(Boolean(message) && 'tooltip tooltip-left')} data-tip={message}>
          <CircleAlert size={16} className="text-error" />
        </span>
      </div>
    </div>
  )
}
